import { NodeModel } from "../_model/NodeModel";
import { DecorationMilling } from "./decorationMilling";
import { Types } from "../../utils/nodeTypes";
import Properties from "../_model/ModelEngineeringProperties";

import { millings } from "./millings";

class Milling extends NodeModel {
    constructor(millingName) {
        super("Milling");

        this.type = new Types().Milling;
        this.x = 0;
        this.y = 0;
        this.yText = () => this.y + this.height / 2 + 5;
        this.xText = () => this.x + this.width / 2;
        this.height = 102;
        this.width = 588;
        this.operationSelected = "";
        this.currentSelected = "";
        this.connectionPack = new Array();
        this.millingInfo = millings[millingName];
        this.currentTempEm = null;
        this.data = [new Properties({...this, height: 0 })];

        this.decorate = async function(callback) {
            this.decorator = new DecorationMilling();
            await this.decorator.init(this, callback);
        };

        this.update = (nodeEdited) => {
            if (nodeEdited.attrs) {
                this.data = nodeEdited.attrs.map(p => ({...p, isInput: true }))
            }

            this.adjustImageSize(nodeEdited);

            this.operationSelected = nodeEdited.operationSelected;
            this.currentSelected = nodeEdited.currentSelected;
            this.millingInfo = JSON.parse(JSON.stringify(nodeEdited.millingInfo));

            this.currentTempEm = nodeEdited.currentTempEm;

            this.decorator.updateImage();
        };

        this.clone = () => {
            let cloned = new Milling(millingName);
            cloned.id = this.id;
            cloned.idName = this.idName;
            cloned.type = this.type;
            cloned.height = this.height;
            cloned.width = this.width;
            cloned.x = this.x;
            cloned.y = this.y;
            cloned.readOnly = this.readOnly;
            cloned.expressionVisible = this.expressionVisible
            cloned.operationSelected = this.operationSelected;
            cloned.currentTempEm = this.currentTempEm;
            cloned.currentSelected = this.currentSelected;
            cloned.data = this.data.map((d) => d.clone());
            cloned.millingInfo = JSON.parse(JSON.stringify(this.millingInfo));
            cloned.connectionPack = this.connectionPack.map((c) => ({
                conn: c.conn.clone(),
                dot: c.dot,
            }));

            return cloned;
        };

        this.copyFrom = (node) => {
            this.simpleCopyFrom(node);
            this.connectionPack = node.connectionPack;
            this.millingInfo = JSON.parse(JSON.stringify(node.millingInfo));
            this.umidade = node.umidade;
            this.embebicao = node.embebicao;
            this.tempEmbebicao = node.tempEmbebicao;
            this.operationSelected = node.operationSelected;
            this.currentSelected = node.currentSelected;
            this.currentTempEm = node.currentTempEm;
            this.data = node.data.map((d) => new Properties({...d }));
            this.connectionPack = node.connectionPack.map((c) => ({
                conn:  new Properties({...c.conn }),
                dot: c.dot,
            }));
        };

        this.removeConnection = (connectionId) => {
            this.connectionPack = this.connectionPack.filter(
                (connection) => connection.conn.id != connectionId
            );
        };

        this.adjustImageSize = (nodeEdited) => {
            if (this.millingInfo.name != nodeEdited.millingInfo.name && nodeEdited.millingInfo.name == "Moenda 4 ternos") {
                this.height = 101;
                this.width = 466;
            } else if (this.millingInfo.name != nodeEdited.millingInfo.name && nodeEdited.millingInfo.name == "Moenda 5 ternos") {
                this.height = 100;
                this.width = 525;
            }
        };

        this.reloadProperties = function() {
            // this.update(this);
        };
    }
}

export { Milling };